import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../core/services/http-data.service';
import { Observable } from 'rxjs';

@Injectable()
export class ReportsService extends HttpDataService {
  public lastReport: any = null;

  constructor(protected injector: Injector) {
    super(injector, '/reporting/personalizations');
  }
  public getReport(reportId: string): Observable<any> {
    return super.getItem(reportId);
  }

  public setLastReport(report: any): void {
    this.lastReport = report;
  }
}
